module.exports = __webpack_public_path__ + "2b28a16bd95ae294415fedf9679cb3c3.mp4";